export const SEARCH_LIMIT = 7
export const searchProperties = [
  'users',
  'posts',
  'tags',
  'groups',
  'events',
] as const

export const SEARCH_VALUE_KEY = 'q'

export const SEARCH_FILTER_KEY = 'filter'

export const SEARCH_GROUP_KEY = 'groupName'

export const SEARCH_CHANNEL_KEY = 'channelName'
